import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appActionsHeaderContent]',
})
export class ActionsHeaderContentDirective {
  public templateRef = inject(TemplateRef<any>);
}
